export default __webpack_public_path__ + "static/animals-logo-809123d69da89961a8c2be28f6d1bdb1.jpg";